import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      You can view other projects on my <a href="https://github.com/zrefai">Github</a>
    </div>
  );
};

export default Footer;
